import api from "../../core/api";
import { Page } from "../../shared/models/models";
import { AdminRfq, AdminRfqsQuery } from "../models/AdminRfqsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.tradingBaseUrl };
}

class AdminRfqsApi {
  getAdminRfqs(query: AdminRfqsQuery): Promise<Page<AdminRfq>> {
    return api.get<Page<AdminRfq>>(`/v1/admin/quotation-requests`, { ...getRequestConfig(), params: query })
      .then(x => x.data);
  }

  getAdminRfq(id: string): Promise<AdminRfq> {
    return api.get<AdminRfq>(`/v1/admin/quotation-requests/${id}`, getRequestConfig()).then(x => x.data);
  }

  deleteAdminRfq(id: string): Promise<any> {
    return api.delete(`/v1/admin/quotation-requests/${id}`, getRequestConfig());
  }
}

export default new AdminRfqsApi();